import React, { Dispatch, SetStateAction, useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Theme, Typography } from '@mui/material';
import deckboxIcon from 'src/svgIcons/deckboxIcon';
import landingIcon from 'src/svgIcons/landingIcon';
import stairIcon from 'src/svgIcons/stairIcon';
import bumpoutIcon from 'src/svgIcons/bumpoutIcon';
import BlockType from 'src/enums/blockType';
import handleAddDeckbox from '../../utils/addDeckbox';
import { DeckContext } from '../../context/DeckContextV3';

const BlockOptions: React.FC<{
	theme: Theme;
	setStage: Dispatch<SetStateAction<number>>;
	setSelectedBlockType: Dispatch<SetStateAction<BlockType | undefined>>;
}> = ({ theme, setStage, setSelectedBlockType }) => {
	const { state, dispatch } = useContext(DeckContext);

	const blocks = [
		{
			name: 'DeckBox',
			color: '#8BC34A',
			icon: deckboxIcon,
			blockType: BlockType.DECKBOX,
		},
		{
			name: 'Landing',
			color: '#FFB200',
			icon: landingIcon,
			blockType: BlockType.LANDING,
		},
		{
			name: 'Stair',
			color: '#FF9800',
			icon: stairIcon,
			blockType: BlockType.STAIR,
		},
		{
			name: 'Bumpout',
			color: '#C3D6AD',
			icon: bumpoutIcon,
			blockType: BlockType.BUMPOUT,
		},
	];

	return (
		<Box sx={{ padding: '5px', width: '350px' }}>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					borderBottom: '1px solid rgba(0, 0, 0, 0.3)',
					marginBottom: '10px',
				}}
			>
				<Typography sx={{ color: theme.palette.gray[500] }}>
					Add Block
				</Typography>

				<IconButton onClick={() => setStage(0)}>
					<CloseIcon sx={{ color: theme.palette.grey[500] }} />
				</IconButton>
			</Box>

			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				{blocks.map((block, index) => (
					<Box
						key={index}
						sx={{
							width: '80px',
							height: '80px',
							paddingX: '15px',
							cursor: 'pointer',
							borderRight:
								index < blocks.length - 1 ? '1px solid rgba(0, 0, 0, 0.2)' : '',
						}}
						onClick={() => {
							if (block.blockType === BlockType.DECKBOX) {
								handleAddDeckbox({
									state,
									dispatch,
								});
								setStage(0);
							} else {
								setSelectedBlockType(block.blockType);
								setStage(2);
							}
						}}
					>
						<Box
							sx={{
								width: '100%',
								height: '70%',
								backgroundColor: block.color,
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								marginBottom: '5px',
							}}
						>
							{block.icon}
						</Box>

						<Typography sx={{ fontSize: '13px', textAlign: 'center' }}>
							{block.name}
						</Typography>
					</Box>
				))}
			</Box>
		</Box>
	);
};
export default BlockOptions;
